var exports = {
  "pz": "sidebar__-G2uXK",
  "J3": "betaLabel__O-g-0z",
  "yF": "divider__TYfVfq",
  "jJ": "sidebarCollapsible__ZC9hD8",
};

module.exports = exports;
